"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * RichWise_Website_API.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfWebSiteMenuStyleSearchModel = instanceOfWebSiteMenuStyleSearchModel;
exports.WebSiteMenuStyleSearchModelFromJSON = WebSiteMenuStyleSearchModelFromJSON;
exports.WebSiteMenuStyleSearchModelFromJSONTyped = WebSiteMenuStyleSearchModelFromJSONTyped;
exports.WebSiteMenuStyleSearchModelToJSON = WebSiteMenuStyleSearchModelToJSON;
exports.WebSiteMenuStyleSearchModelToJSONTyped = WebSiteMenuStyleSearchModelToJSONTyped;
/**
 * Check if a given object implements the WebSiteMenuStyleSearchModel interface.
 */
function instanceOfWebSiteMenuStyleSearchModel(value) {
    return true;
}
function WebSiteMenuStyleSearchModelFromJSON(json) {
    return WebSiteMenuStyleSearchModelFromJSONTyped(json, false);
}
function WebSiteMenuStyleSearchModelFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'orderString': json['orderString'] == null ? undefined : json['orderString'],
        'currentPage': json['currentPage'] == null ? undefined : json['currentPage'],
        'pageSize': json['pageSize'] == null ? undefined : json['pageSize'],
        'menuNo': json['menuNo'] == null ? undefined : json['menuNo'],
        'active': json['active'] == null ? undefined : json['active'],
    };
}
function WebSiteMenuStyleSearchModelToJSON(json) {
    return WebSiteMenuStyleSearchModelToJSONTyped(json, false);
}
function WebSiteMenuStyleSearchModelToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'orderString': value['orderString'],
        'currentPage': value['currentPage'],
        'pageSize': value['pageSize'],
        'menuNo': value['menuNo'],
        'active': value['active'],
    };
}
